import React from 'react'
import type { Props } from './types'
import { ImageMedia } from './ImageMedia'

export const Media: React.FC<Props> = (props) => {
  return <ImageMedia {...props} />
}
